import DOMPurify from 'dompurify';

/**
 * Sanitiza entrada de texto para prevenir XSS
 * @param {string} input - Texto a ser sanitizado
 * @returns {string} - Texto sanitizado
 */
export const sanitizeInput = (input) => {
    if (typeof input !== 'string') {
        return input;
    }
    return DOMPurify.sanitize(input, { ALLOWED_TAGS: [] });
};

/**
 * Valida e sanitiza email
 * @param {string} email - Email a ser validado
 * @returns {string|null} - Email sanitizado ou null se inválido
 */
export const sanitizeEmail = (email) => {
    const sanitized = sanitizeInput(email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(sanitized) ? sanitized : null;
};

/**
 * Valida quantidade numérica
 * @param {number|string} value - Valor a ser validado
 * @param {number} min - Valor mínimo permitido
 * @param {number} max - Valor máximo permitido
 * @returns {number|null} - Número validado ou null se inválido
 */
export const validateNumber = (value, min = 1, max = 1000) => {
    const num = Number(value);
    if (isNaN(num) || num < min || num > max) {
        return null;
    }
    return num;
};

/**
 * Sanitiza código regional
 * @param {string} regional - Código regional a ser validado
 * @returns {string|null} - Regional válida ou null
 */
export const sanitizeRegional = (regional) => {
    const validRegionals = ['CR', 'GR', 'PT', 'ST', 'AV', 'RF', 'OR'];
    const sanitized = sanitizeInput(regional).toUpperCase().trim();
    return validRegionals.includes(sanitized) ? sanitized : null;
};
